import { gateway } from "../../../gateway";
import { CreateRemindersConfig } from "../interfaces/create-reminder.interface";

export const createRemindersConfig = async (data: CreateRemindersConfig) => {
    const res = await gateway.post("reminders-settings/", data);
    return res;
};